// src/belediye/pages/sohbet/YeniSohbetPage.js
//
// FAZ-94 madde 21, 22 — "YENİ SOHBET" TAM SAYFA (telefon).
//
// Kullanıcı: "…yanında geri butonu var ya, bu geri butonuna tıklayınca
// sohbetler sayfasına gelmesin, ilk gidilen liste sayfasına gelsin."
//
// İsteğin çekirdeği: **"nereden geldim"** bilgisi taşınmalı. `/yonetim/talepler`
// sayfasındaki + düğmesinden gelindiyse geri → oraya; sohbet listesinden
// gelindiyse geri → sohbet listesine.
//
// Taşıyıcı `location.state`: React Router'ın kendi mekanizması, ayrı bir depo
// kurmaya gerek yok. Sayfa yenilenirse state boşalır → güvenli varsayılan
// sohbet listesi (yanlış yere göndermektense bilinen yere göndermek).

import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import NewChatPanel from "../../components/mesajlasma/NewChatPanel";
import TaskFlowPanel from "../../components/mesajlasma/TaskFlowPanel";
import { useNavbarBasligiAyarla } from "../../components/NavbarBaslikContext";
import "../../components/mesajlasma/chat.css";
import "./sohbet.css";

export default function YeniSohbetPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const donus = location.state?.donus || "/yonetim/sohbet";

  /* G9 — GÖREV-ÖNCE AKIŞI BU SAYFADA KALIR.
     `serbest` kapalı + `gorev` açık kurulumda "Yeni" sohbet BAŞLATMAZ; yalnız
     kişi seçer ve görev sihirbazı açılır — conversation ancak görev doğunca
     oluşur. Pencerede bu sihirbaz sağ panede çiziliyordu. Telefonda pencere
     yok; köprüyle başka yere göndermek akışı ortadan ikiye bölerdi. Aynı
     sayfada, panelin YERİNE çizilir. */
  const [taskFlow, setTaskFlow] = useState(null);

  /* Navbarın orta yuvası: "Yeni Sohbet". `tur: "kayit"` KRİTİK — sol yuva
     yalnız kayıtta geri okuna döner (FAZ-92); "sayfa" deseydik geri oku
     hiç belirmezdi ve bu akıştan çıkış yolu kalmazdı. */
  useNavbarBasligiAyarla({ ad: "Yeni Sohbet", tur: "kayit" });

  /* Kişi seçimi tam ekran bir akış; alt bar burada yer kaplamamalı.
     Navbar DURUYOR: geri oku ve "Yeni Sohbet" başlığı oradan geliyor. */
  useEffect(() => {
    const kok = document.documentElement;
    kok.setAttribute("data-msj-ekran", "yeni");
    return () => kok.removeAttribute("data-msj-ekran");
  }, []);

  /* FAZ-94 madde 22 — `replace: true`. Sohbet açıldıktan sonra geri tuşu kişi
     listesine DÖNMEMELİ: kullanıcı seçimini yaptı, oraya dönmek "seçimi geri
     al" gibi okunur ama öyle çalışmaz. */
  const acildi = (convId) =>
    navigate(`/yonetim/sohbet/${convId}`, { replace: true, state: { donus } });

  return (
    <div className="sohbet-yeni">
      {taskFlow ? (
        <TaskFlowPanel
          targets={taskFlow.targets}
          unitTarget={taskFlow.unitTarget}
          onStarted={(id) => {
            setTaskFlow(null);
            acildi(id);
          }}
          onClose={() => setTaskFlow(null)}
        />
      ) : (
        <NewChatPanel
          onStarted={acildi}
          onCancel={() => navigate(donus)}
          onStartTaskFlow={setTaskFlow}
        />
      )}
    </div>
  );
}
